export interface RutParts {
	rut: number | null;
	dv: string | null;
}

export class RutHelper {
	private static readonly DV_CHARS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "K"];

	static clean(rutString: string): string {
		if (!rutString) return "";
		return rutString.toUpperCase().replace(/\./g, "").replace(/-/g, "").trim();
	}

	static parse(rutString: string): RutParts {
		const clean = RutHelper.clean(rutString);
		if (clean.length < 2) return { rut: null, dv: null };
		const dv = clean.slice(-1);
		const mantisa = clean.slice(0, -1);
		const parsed = parseInt(mantisa, 10);
		if (isNaN(parsed)) return { rut: null, dv: null };
		return { rut: parsed, dv };
	}

	static format(rutString: string): string {
		const clean = RutHelper.clean(rutString);
		if (clean.length < 2) return clean;
		const mantisa = clean.slice(0, -1);
		const dv = clean.slice(-1);
		if (isNaN(+mantisa) && dv !== "K") return clean;
		return `${mantisa}-${dv}`;
	}

	// Misma presentación de Payku; format() conserva el contrato sin puntos.
	static formatInput(value: string): string {
		const clean = (value || "").toUpperCase().replace(/[^0-9K]/g, "");
		if (clean.length < 2) return clean;
		const body = clean.slice(0, -1).replace(/K/g, "");
		return body ? `${body.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}-${clean.slice(-1)}` : clean.slice(-1);
	}

	static validate(rutString: string): boolean {
		if (!rutString || !/^[0-9kK.\-]+$/.test(rutString.trim())) return false;
		const clean = RutHelper.clean(rutString);
		const dv = clean.slice(-1);
		if (!RutHelper.DV_CHARS.includes(dv)) return false;
		const mantisa = clean.substring(0, clean.length - 1);
		if (!mantisa.match(/^\d+$/)) return false;
		if (mantisa.length > 8) return false;

		let suma = 0;
		let multiplo = 2;
		for (let i = 1; i <= mantisa.length; i++) {
			suma += multiplo * parseInt(mantisa.charAt(mantisa.length - i), 10);
			multiplo = multiplo < 7 ? multiplo + 1 : 2;
		}

		let dvEsperado = (11 - (suma % 11)).toString();
		let dvNormalizado = dv === "K" ? "10" : dv === "0" ? "11" : dv;
		return dvEsperado === dvNormalizado;
	}
}
